/** Selected dev operator, shared by browser bootstrap and real-session fixtures. */
export const OPS_DEV_USER_STORAGE_KEY = "novemai.opsDevAuthUser";
